import React from 'react'

const ThankYou = () => {
  return (
    <>
        <section className='thank-you-wrap'>
            <div className='container'>
                <div className='thank-you-block text-center'>
                    <div className='lg-title text-center mb-4'>Thank You for Reaching Out</div>
                    <p>Our friendly staff with reach out to you shortly.<br/>
                    If you have a more urgent request feel free to call us anytime at (830) 981-5050.<br/>
                    We look forward to talking with you very soon.</p>
                </div>
            </div>
        </section>
    </>
  )
}

export default ThankYou